import * as React from 'react';
import { Box, Grid, Modal } from '@mui/material';
import RoundButton from '../components/roundButton';

export default function ModalAccept({
  open,
  modalValue,
  handleClose,
  handleAccept
}) {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box className="modal-common accept-modal">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            The value you selected is inconsistent with other choices that you
            have made.
          </Grid>

          {modalValue.changed?.map((items, i) => {
            return (
              <div key={items.description} className="display-contents lh-2">
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  className="accept-align bold"
                >
                  <span> Option: </span>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <span>{items.description}</span>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  className="accept-align bold"
                >
                  <span> Your Selection:</span>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <span>{items.oldValueDescription}</span>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  className="accept-align bold"
                >
                  <span> Proposed Change:</span>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <span>{items.newValueDescription}</span>
                </Grid>
              </div>
            );
          })}
          <Grid item xs={12}>
            Would you like to accept these changes?
          </Grid>
          <Grid item xs={0} sm={6} md={6} lg={6}></Grid>
          <Grid item xs={6} sm={3} md={3} lg={3} className="pr-h-5">
            <RoundButton
              name="Cancel"
              onClick={() => {
                handleClose();
              }}
            />
          </Grid>
          <Grid item xs={6} sm={3} md={3} lg={3}>
            <RoundButton
              name="Accept"
              onClick={() =>
                handleAccept(
                  modalValue.value,
                  modalValue.key,
                  modalValue.configState
                )
              }
            />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
